import { useIntl } from 'react-intl';
import { RangeSliderFilterConfig } from '@alltrails/denali/components/FilterBar';
import ExploreServiceFilters from '../../types/ExploreServiceFilters';
import useRangeSliderFilterConfig, { getValidRangeSliderValue } from './useRangeSliderFilterConfig';

const kmValues = [
  ...Array.from(Array(41).keys()), // 0-40
  48,
  56,
  64,
  72,
  80
];

const miValues = [
  ...Array.from(Array(26).keys()), // 0-25
  30,
  35,
  40,
  45,
  50
];

export const getValidLength = (meters: number, useMetric: boolean) =>
  getValidRangeSliderValue(meters, miValues, 'mile', kmValues, 'kilometer', useMetric);

const useLengthFilterConfig = (
  exploreServiceFilters: ExploreServiceFilters,
  onFiltersChange: (updatedFilters: ExploreServiceFilters) => void,
  useMetric: boolean
): RangeSliderFilterConfig => {
  const intl = useIntl();

  return useRangeSliderFilterConfig(
    exploreServiceFilters,
    onFiltersChange,
    'length',
    intl.formatMessage({ defaultMessage: 'Length' }),
    miValues,
    'mile',
    kmValues,
    'kilometer',
    useMetric
  );
};

export default useLengthFilterConfig;
